"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
/**
 * 左侧
 * @param props
 * @constructor
 */
var LeftSide = function (props) {
    var onChangeTab = props.onChangeTab, data = props.data, execute = props.execute, activeTab = props.activeTab;
    return (react_1.default.createElement("div", { className: "left-side-layout" }, data.map(function (item, index) { return (react_1.default.createElement("div", __assign({ className: (0, classnames_1.default)('list', {
            active: activeTab === index,
            play: execute,
        }), onClick: function () { return onChangeTab(Number(index)); }, key: index }, (item.extendProps || {})),
        react_1.default.createElement("span", { className: "title" }, item.title),
        react_1.default.createElement("div", { className: "describe" }, item.describe),
        react_1.default.createElement("div", { className: "process" },
            react_1.default.createElement("span", { className: "process-bar" })))); })));
};
exports.default = LeftSide;
//# sourceMappingURL=LeftSide.js.map